import { ProductivityDashboardItemSchema } from "@redotech/redo-model/outbound-labels/productivity-dashboard";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getProductivityDashboardData = {
  name: "getProductivityDashboardData" as const,
  input: z.object({
    search: z.string().nullish(),
    filters: z.record(z.string(), z.string()),
    sort: z
      .object({ key: z.string(), direction: createEnum(["asc", "desc"]) })
      .nullish(),
  }),
  output: z.object({
    data: z.array(ProductivityDashboardItemSchema),
    live: z.boolean().nullish(),
  }),
};
